(function() {
    'use strict';
    if(typeof window.searchspring === 'undefined') {
      window.searchspring = {};
    }
    window.searchspring.translations = {
      searchTitle: "Resultado de búsqueda",
      products: "Productos",
      collections: "Collecciones",
      articles: "Articulos",
      pages: "Paginas",
      searchForProduct: "Buscar productos",
      search: "Búsqueda actual",
      allProducts: "Mostrar Más",
      sortBy: "Ordenado por",
      relevance: "Relevancia",
      outOf: "de ",
      oneResultFound: "resultados encontrados",
      noResultFound: "resultados no encontrados",
      addToCart: "añadir a la cesta",
      selectedFilter: "Filtros seleccionados",
      clearAll: "Limpiar todo",
      outOfStock: "Agotado",
      try: "Intentar",
      clearFilters: "Limpiar los filtros",
      or: "o",
      changeInput: "cambiando tu entrada",
      showLess: "Mostrar Menos",
      showMore: "Mostrar Más",
      didYouMean: "¿Querías decir?",
      viewing: "viendo",
      drawerSearchResultsTitleEmpty: "Artículos de tendencia",
      drawerSearchResultsTitle: "Mejores resultados para",
      drawerQuerySuggestionsTitle: "¿Querías decir?",
      drawerQuerySuggestionsTitleEmpty: "Categorias populares",
      noResultFor: "No se encontraron resultados para",
      in: "en",
      by: "por",
      showFilters: "Mostrar filtros",
      hideFilters: "Ocultar filtros",
      drawerViewCountResults: "Ver __count__ resultados por",
      filters: "Filtros",
      instalments: "Paga en __instalments__ de __fixedInstalments__ sin intereses"
    };

  window.searchspring.translation_helpers = {
    no_result_for: function(text) {
      // return 'No result for " ' + text + ' ".';
      return window.searchspring.translations.noResultFor + ' " ' + text + ' ".';
    },
    in: function(processingTimeMS) {
      // return 'in ' + processingTimeMS / 1000 + 's';
      return window.searchspring.translations.in + ' ' + processingTimeMS / 1000 + 's';
    },

    outOf: function(page, hitsPerPage, nbHits) {
      return (
        page * hitsPerPage +
        1 +
        '-' +
        Math.min((page + 1) * hitsPerPage, nbHits) +
        window.searchspring.translations.outOf
      );
    },

    by: function(text) {
      if (!text) return '';
      // return ' by ' + text;
      return ' ' + window.searchspring.translations.by + ' ' + text;
    },
  };
})();